if (!customElements.get('related-products-slider')) {
  class RelatedProductsSlider extends HTMLElement {
    slider = {};
    selectors = {
      swiper: '.swiper',
    }

    constructor() {
      super();
    }

    connectedCallback() {
      this.slider = new Swiper(this.querySelector(this.selectors.swiper), {
        slidesPerView: 2.2,
        spaceBetween: 0,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 4,
          },
          1024: {
            slidesPerView: 5.5,
          },
        },
      });
    }
  }
  customElements.define('related-products-slider', RelatedProductsSlider);
}
